import { Component } from "@angular/core";
import { SettingsService } from "../../../shared/services/settings.service";
import { TranslateDirective } from "../../../shared/transloco/translate.directive";
import { NewUiMilestoneCandidateViewComponent } from "../../milestones/milestone-candidate-view/new-ui-milestone-candidate-view.component";
import { NewUiDashboardCardHeaderComponent } from "../layout/new-ui-dashboard-card-header/new-ui-dashboard-card-header.component";
import { NewUiDashboardCardComponent } from "../layout/new-ui-dashboard-card/new-ui-dashboard-card.component";

@Component({
  selector: "new-ui-dashboard-milestone-candidate",
  templateUrl: "./new-ui-dashboard-milestone-candidate.component.html",
  imports: [
    NewUiDashboardCardHeaderComponent,
    TranslateDirective,
    NewUiDashboardCardComponent,
    NewUiMilestoneCandidateViewComponent,
  ],
})
export class NewUiDashboardMilestoneCandidateComponent {
  constructor(private readonly settingsService: SettingsService) {}

  protected readonly candidateId = this.settingsService.userOrCandidateId;
  protected readonly organizationId = this.settingsService.organizationId;
}
